import React from 'react';

const AboutDetails = () => {
  return (
    <div className="about-details">
      <h1>Więcej o SiteForge AI</h1>
      <p>Tutaj znajdą się szczegółowe informacje o firmie.</p>
    </div>
  );
};

export default AboutDetails;
